import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { map } from 'rxjs/operators'
import { VinculoSupervisorService } from '../vinculo-supervisor.service'

@Injectable({
  providedIn: 'root',
})
export class DefinirSenhaService implements CanActivate {
  constructor(private router: Router, private vinculoSupervisorService: VinculoSupervisorService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.vinculoSupervisorService.needChangePassword(route.params.token).pipe(
      map((needChangePassword) => {
        if (!needChangePassword) {
          return this.router.parseUrl('/login')
        }

        return true
      })
    )
  }
}
